import { render, staticRenderFns } from "./SystemConfigExpress.vue?vue&type=template&id=9f2f0a9e&"
import script from "./SystemConfigExpress.vue?vue&type=script&lang=js&"
export * from "./SystemConfigExpress.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigExpress.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports